import { render, staticRenderFns } from "./StudentTasks.vue?vue&type=template&id=a721f610&"
import script from "./StudentTasks.vue?vue&type=script&lang=js&"
export * from "./StudentTasks.vue?vue&type=script&lang=js&"
import style0 from "./StudentTasks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports